<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header
        pageTitle="FMR-14R: Requested Authorization Report"
      ></Header>
      <div class="row justify-contnet-center">
        <div class="col-md-12 subtitle">
          {{ subtitle }}
        </div>
       
      </div>
      <div class="row justify-content-center">
       
        <div class="col-md-3">
          <label>Country:</label>

          <v-select
            v-model="countryId"
            name="PartnerNationDropdown"
            :reduce="(item) => item.countryId"
            label="name"
            :options="countries"
            placeholder="Select"
          ></v-select>
        </div>

        <div class="col-md-3">
          <label>Fiscal Year:</label>

          <base-input>
            <v-select
              v-model="year"
              name="FiscalYear"
              :reduce="(item) => item.year"
              label="label"
              :options="fiscalYears"
              placeholder="Select"
            ></v-select>
          </base-input>
        </div>
      </div>
      <br />
      <div class="row justify-content-center">
        <div class="col-md-2">
          <base-button
            @click="initializeAllData()"
            type="danger"
            v-b-popover.hover.top="'Reset all fields!'"
          >
            <i class="tim-icons icon-alert-circle-exc"></i> Clear
          </base-button>
        </div>

        <div class="col-md-2">
          <base-button
            @click="getData"
            type="primary"
            v-b-popover.hover.bottom="'Generate Report!'"
          >
            <i class="tim-icons icon-atom"></i> Generate
          </base-button>
        </div>
      </div>
    </div>
    <br />

    <!--  <div class="card card-body agatrs-card-style" v-if="aors?.length <= 0">
      <div class="card-container">
        <div class="title">
          <h4>No Results</h4>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-12">
          <br />
          <div style="padding: 20px 40px">
            No data was found for the selected criteria
          </div>
        </div>
      </div>
    </div>-->

    <div class="card card-body agatrs-card-style" v-if="html !== ''">
      <div class="card-container">
        <div class="print" style="margin-bottom: 5px">
          <base-button @click="print" class="btn-dark">PRINT</base-button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-12">
          <br />
          <div style="padding: 20px 40px">
            <div id="report" v-html="html"></div>
          </div>
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "@/axios";
import Header from "@/components/App/Header.vue";
import Treeselect from "@riophae/vue-treeselect";
import Utility from "@/mixins/utility/utility";
import Util from "@/util/util";

export default {
  name: "FmrReports",
  mixins: [Utility],
  components: {
    Header,
    Treeselect,
  },
  data() {
    return {
      countryId: null,
      year: null,
      html: "",
      subtitle: "The Requested Authorization Report displays LSSS payments and purchases obligated or earned by the United States and is outlined by type of support per country and fiscal year as entered into AGATRS."
    };
  },
  async mounted() {
    this.$loaderApp.addRequest();
    await this.getAllCountries();
    await this.getFiscalYears();
    this.$loaderApp.completeRequest();
  },
  computed: {
    ...mapGetters({
      countries: "countries/allCountries",
      fiscalYears: "fiscalYears/fiscalYears",
    }),
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getFiscalYears: "fiscalYears/getFiscalYears",
    }),
    initializeAllData() {
      Object.assign(this.$data, this.$options.data());
    },
    getData() {
      var ctx = this;
      this.$loaderApp.addRequest();
      axios({
        url: "/api/fmrs/requestedauthorzation/html",
        method: "POST",
        data: { countryId: ctx.countryId, fiscalYear: ctx.year },
        config: { showToast: false, showLoader: true },
      }).then((response) => {
        ctx.html = response.data;
        ctx.$loaderApp.completeRequest();
      }).catch((error) => {
        this.$toast.error(error.response.data.message);
      });
    },
    print() {
      let ctx = this;
      //this.$loaderApp.addRequest();
      axios({
        url: "/api/fmrs/requestedauthorzation/pdf",
        method: "POST",
        data: { countryId: ctx.countryId, fiscalYear: ctx.year },
        config: { showToast: false, showLoader: true },
        responseType: "blob", // important
      }).then((response) => {
        Util.fileDownload(
          response.data,
          "ASCA FMR-14R Requested_Authorization.pdf"
        );
        //ctx.$loaderApp.completeRequest();
      }).catch((error) => {
        this.$toast.error(error.response.data.message);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  max-width: 100%;
  min-width: 400px;
  .print {
    margin: auto;
    margin-left: 0px;
    padding: 0px;
    flex-grow: 1;
    text-align: left;
  }
  .title {
    margin: auto;
    margin-left: 0px;
    padding: 0px;
    text-align: center;
    flex-grow: 1;
    text-align: left;
    align-items: center;
    .title > h2 {
      text-align: left !important;
    }
  }
  .disabled {
    pointer-events: none;
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
  }
}

.subtitle {
    padding-left: 15% !important;
    padding-right: 15% !important;
    padding-bottom: 50px !important;
  }
</style>
